import { render, staticRenderFns } from "./BankConfig.vue?vue&type=template&id=cbf8f812&"
import script from "./BankConfig.vue?vue&type=script&lang=ts&"
export * from "./BankConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports